import { IOption } from "../types";

import { ICustomOption, IOptionMixin } from "./types";

export const isCustomOption = (
  maybeCustomOption: IOption | ICustomOption
): maybeCustomOption is ICustomOption => {
  return "onValueChange" in maybeCustomOption;
};

export const getLabel = <T extends string = string>(option: IOption<T>) =>
  option.label;
export const getValue = <T extends string = string>(option: IOption<T>): T =>
  option.value;

const getModularIndex = (index: number, maxValue: number) =>
  ((index % maxValue) + maxValue) % maxValue;

/**
 * Get the next non-disabled index
 */
export const getNextIndex = <T extends string>(
  eventKey: "ArrowDown" | "ArrowUp",
  options: IOptionMixin<T>[],
  highlightIndex: number
): number => {
  const optionsCount = options.length;
  let nextIndex = highlightIndex;

  for (let i = 0; i < optionsCount; ++i) {
    nextIndex = nextIndex + (eventKey === "ArrowDown" ? 1 : -1);
    nextIndex = getModularIndex(nextIndex, optionsCount);

    const nextOption = options[nextIndex];
    if (nextOption && !nextOption.disabled) {
      return nextIndex;
    }
  }
  // we've iterated over all possibilities, let's keep the same option
  return highlightIndex;
};
